// 检查设备是安卓还是苹果
export function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

export function isIOS() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }
  return false;
}

export function isAndroid() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  return false;
}

// 检查设备是不是微信
export function isMicroMessenger() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/MicroMessenger/i.test(userAgent)) {
    return true;
  }
  return false;
}

// 检查设备是不是微信
export function is70mai() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/70mai/i.test(userAgent)) {
    return true;
  }
  return false;
}

// 检查设备是不是微信
export function userAgent() {
  return navigator.userAgent || navigator.vendor || window.opera;
}

//获取多语言字段

export function getUserLang() {
  const urlParams = new URLSearchParams(window.location.search);
  console.log(urlParams.get('user_lang'));
  return urlParams.get('user_lang') || 'en';
}

export function setCursorPosition(elem) {
  var val = elem.value;
  var len = val.length;
  setTimeout(function () {
    elem.focus();
    if (elem.setSelectionRange) {
      elem.setSelectionRange(len, len);
    }
  }, 30);
}
